import { Directive, Output, EventEmitter, ElementRef, OnInit,  OnDestroy } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, mergeMap, take, takeUntil } from 'rxjs/operators';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
    @Output() clickOutside = new EventEmitter<void>();

    natsearch = new Subject();
    natsearch$ = this.natsearch.asObservable();
    private unsubscribe$ = new Subject();

    constructor (private elementRef: ElementRef) { }

    ngOnInit (): void {
        const clickOutside$ = fromEvent(document, 'click').pipe(
            filter(({ target }) => {
                return this.elementRef.nativeElement.contains(target) === false
            }),
            take(1)
        );

        this.natsearch$.pipe(
            takeUntil(this.unsubscribe$),
            mergeMap(() => clickOutside$)
        ).subscribe(_ => {
            this.clickOutside.emit();
        });

        setTimeout(() => {
            this.natsearch.next(true);
        }, 50);
    }

    
    ngOnDestroy (): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
